import React from "react";
import { useHistory } from "react-router-dom";
import { Card, Grid } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";
import { AUTH_PREFIX_PATH } from "configs/AppConfig";

const UnauthorisedPage = () => {
  const history = useHistory();

  const handleGoToLogin = () => {
    history.push(AUTH_PREFIX_PATH);
  };

  return (
    <VuiBox py={3}>
      <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: "80vh" }}>
        <Grid item xs={12} md={6}>
          <Card sx={{ p: 3, backgroundColor: "rgba(0,0,0,0.2)", textAlign: "center" }}>
            <VuiBox py={4}>
              <VuiTypography variant="h2" color="error" fontWeight="bold" mb={2}>
                Access Denied
              </VuiTypography>
              <VuiTypography variant="body1" color="white" mb={4}>
                You do not have permission to access this page.
                <br />
                Please contact your administrator if you believe this is an error.
              </VuiTypography>
              {/* @ts-ignore */}
              <VuiButton
                variant="contained"
                color="primary"
                onClick={handleGoToLogin}
              >
                Go to Login
              </VuiButton>
            </VuiBox>
          </Card>
        </Grid>
      </Grid>
    </VuiBox>
  );
};

export default UnauthorisedPage;